import React, { useEffect, useRef, useState } from 'react';
import { NavigateBeforeRounded, NavigateNextRounded } from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';

export type PaginationProps = {
    currentPage: number;
    eventsCount: number;
    setRowsPerPage: Function;
    setCurrentPage: Function;
    rowsPerPage: number;
    callBackFunc: Function;
    dynamicTextColors?: any;
}

const Pagination: React.FC<PaginationProps> = (props) => {
    const { t } = useTranslation();
    const { currentPage, eventsCount, setCurrentPage, setRowsPerPage, rowsPerPage, callBackFunc, dynamicTextColors } = props;
    const curList = [10, 20, 50, 100];
    const [isOpen, setIsOpen] = useState(false);
    const toggleDropdown = () => setIsOpen(!isOpen);

    // Get dynamic text color classes from props
    const pageTextColorClass = dynamicTextColors?.pageTextColorClass || '';
    const inputBoxTextColorClass = dynamicTextColors?.inputBoxTextColorClass || '';
    const buttonTextColorClass = dynamicTextColors?.buttonTextColorClass || '';


    const handleCurrencySelect = (curr: any) => {
        setRowsPerPage(curr)
        setIsOpen(false);
    };

    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
        } else {
            callBackFunc();
        }
    }, [currentPage, rowsPerPage]);

    useEffect(() => {
        setCurrentPage(1);
    }, [rowsPerPage])

    return (
        <>
            <div className="flex items-center justify-between">
                <div className='flex items-center'>
                    <div className={`text-sm ${pageTextColorClass} ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: pageTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>{t("common.rowsPerPage")}</div>
                    <div className="relative h-[30px]">
                        <button
                            onClick={toggleDropdown}
                            className={`flex items-center h-full justify-between px-3 py-2 text-sm font-medium whitespace-nowrap rounded-lg ${inputBoxTextColorClass} ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                            style={{ color: inputBoxTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                        >
                            <span>{rowsPerPage}</span>
                        </button>

                        {isOpen && (
                            <ul className="absolute z-10 bottom-full mb-1 bg-inputbox-color border border-slate-800 rounded-lg shadow-lg w-full">
                                {curList?.map((curr) => (
                                    <li
                                        key={curr}
                                        onClick={() => handleCurrencySelect(curr)}
                                        className={`px-3 py-2 text-xs hover:bg-zinc-700 cursor-pointer ${inputBoxTextColorClass} ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                        style={{ color: inputBoxTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                                    >
                                        {curr}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
                <div>
                    <div
                        className={`pagination-btn ${buttonTextColorClass} ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        onClick={() => setCurrentPage(currentPage - 1)}
                        style={{ color: buttonTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                    >{
                            currentPage !== 1 ? (
                                <NavigateBeforeRounded />
                            ) : <></>
                        }
                    </div>
                </div>
                <div className={`text-sm pagination-pages ${pageTextColorClass} ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: pageTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>
                    {currentPage === 1 ? currentPage : currentPage * rowsPerPage - rowsPerPage + 1} - {currentPage * rowsPerPage > eventsCount ? eventsCount : currentPage * rowsPerPage} {t("common.of")} {eventsCount}
                </div>
                <div className='flex'>
                    <div>
                        <div
                            className={`pagination-btn ${buttonTextColorClass} ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                            onClick={() => setCurrentPage(currentPage + 1)}
                            style={{ color: buttonTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                        >
                            {
                                (currentPage * rowsPerPage) < eventsCount ?
                                    <NavigateNextRounded /> : <></>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Pagination;